module.exports = __webpack_public_path__ + "static/media/OLIVE-AVAX.aea9f26f.png";